import { type Color, type KitIconName, Tag, type TagProps } from '@eleo-rh/core-ui'

import FileTypeIcon from 'components/FileTypeIcon'

interface DocumentTagProps {
  '@id': string
  name: string
  extension: string
  handleClick: () => void
}

const getColor = (ext: string) => {
  switch (ext) {
    case 'doc':
    case 'docx':
    case 'txt':
      return 'blue'
    case 'xls':
    case 'xlsx':
      return 'green'
    case 'png':
    case 'jpg':
    case 'jpeg':
      return 'orange'
    case 'ppt':
    case 'pptx':
      return 'purple'
    case 'pdf':
      return 'red'
    default:
      return 'grey'
  }
}

export default function DocumentTag(props: DocumentTagProps & TagProps) {
  const { '@id': _id, extension, handleClick, name, onClick, ...rest } = props

  return (
    <Tag
      className="cursor-pointer"
      leftIcon={`file-${extension || 'pdf'}` as KitIconName}
      color={getColor(extension) as Color}
      {...rest}
      onClick={event => {
        onClick?.(event)
        if (!event.defaultPrevented) {
          handleClick()
        }
      }}
    >
      <span>{name}</span>
    </Tag>
  )
}
